export default __webpack_public_path__ + "static/media/notification.1d7c97df.mp3";